import { format as dateFormat } from 'date-fns/format';

export const dateInIsoToHumanReadable = (date: string): string => {
  return dateFormat(new Date(date), 'dd-MM-yyyy');
};
